__turbopack_context__.v({
  "container": "ErrorMessage-module__4sCFvW__container",
  "content": "ErrorMessage-module__4sCFvW__content",
});
